import { Card, Typography } from 'antd'
import miscApi from 'api/miscApi'
import { setAppSpinning } from 'app/appSlice'
import AppResource from 'general/constants/AppResource'
import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useSearchParams } from 'react-router-dom'
import AmbiguousPicker from './components/AmbiguousPicker'
import ModalViewInvoice from './components/ModalViewInvoice'
import NotFoundError from './components/NotFoundError'
import './style.scss'

function Search() {
  const dispatch = useDispatch()
  const [searchParam] = useSearchParams()
  const initialLookupCode = searchParam.get('lookupCode')
  const [invoiceLookupCode, setInvoiceLookupCode] = useState('')
  const [invoice, setInvoice] = useState()
  const [showModalViewInvoice, setShowModalViewInvoice] = useState(false)

  const [notFoundInvoiceLookupCode, setNotFoundInvoiceLookupCode] = useState()
  const [candidates, setCandidates] = useState(null)

  const [invoiceUrl, setInvoiceUrl] = useState()

  const openWithRecord = useCallback(
    async (record) => {
      const resPdf = await miscApi.exportLookupCode(record.token)
      const newFile = new File([resPdf], 'Mẫu hóa đơn.pdf', { type: 'application/pdf' })
      const fileURL = URL.createObjectURL(newFile)
      setInvoice(record)
      setInvoiceUrl(fileURL)
      setShowModalViewInvoice(true)
    },
    [],
  )

  const handleSearchInvoice = useCallback(
    async (lookupCode) => {
      dispatch(setAppSpinning(true))
      try {
        const res = await miscApi.findByLookupCode(lookupCode)
        setCandidates(null)
        setNotFoundInvoiceLookupCode(null)
        await openWithRecord(res.data)
      } catch (e) {
        const errData = e?.response?.data
        if (errData?.errorCode === 'LOOKUP_AMBIGUOUS' && Array.isArray(errData.candidates)) {
          setCandidates(errData.candidates)
          setNotFoundInvoiceLookupCode(null)
        } else {
          setCandidates(null)
          setNotFoundInvoiceLookupCode(lookupCode)
        }
      } finally {
        dispatch(setAppSpinning(false))
      }
    },
    [dispatch, openWithRecord],
  )

  const handlePickCandidate = useCallback(
    async (candidate) => {
      dispatch(setAppSpinning(true))
      try {
        setCandidates(null)
        await openWithRecord(candidate)
      } catch (e) {
        setNotFoundInvoiceLookupCode(candidate?.lookupCode || '')
      } finally {
        dispatch(setAppSpinning(false))
      }
    },
    [dispatch, openWithRecord],
  )

  useEffect(() => {
    if (initialLookupCode) {
      setInvoiceLookupCode(initialLookupCode)
      handleSearchInvoice(initialLookupCode)
    }
  }, [handleSearchInvoice, initialLookupCode])

  return (
    <>
      <div className="Search">
        <div className="top-bar">
          <Link
            to="/"
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <img src={AppResource.images.img_SONPHAT_logo} width={100} />
          </Link>
        </div>

        <div>
          <div
            className="layout-tra-cuu d-flex justify-content-center"
            style={{ marginBottom: '4em' }}
          >
            <div className="d-flex align-items-center justify-content-center col-12">
              <div className="row" style={{ width: '41%' }}>
                <div className="col-12 mb-5">
                  <div className="text-white text-center">
                    <h4 className="font-medium text-2xl m-0">
                      TRA CỨU HÓA ĐƠN ĐIỆN TỬ
                      <br />
                      SƠN PHÁT
                    </h4>
                  </div>
                </div>
                <div className="col-12 mb-7">
                  <input
                    placeholder="Nhập mã tra cứu"
                    className="w-100 search-input"
                    required
                    value={invoiceLookupCode}
                    onChange={(e) => {
                      setInvoiceLookupCode(e.target.value)
                    }}
                    onKeyDown={(e) => {
                      if (e.key == 'Enter') {
                        handleSearchInvoice(invoiceLookupCode)
                      }
                    }}
                  />
                </div>
                <div className="col-12">
                  <div className="text-center">
                    <button
                      className="btn btn-success d-inline-flex align-items-center"
                      onClick={() => handleSearchInvoice(invoiceLookupCode)}
                    >
                      <i className="fa-regular fa-magnifying-glass"></i>
                      <span style={{ fontSize: '16px' }}>Tra cứu</span>
                    </button>
                  </div>
                </div>

                {notFoundInvoiceLookupCode && (
                  <div className="col-12">
                    <NotFoundError
                      text={`Không tìm thấy hóa đơn có mã tra cứu: ${notFoundInvoiceLookupCode}`}
                    />
                  </div>
                )}

                {candidates?.length > 0 && (
                  <div className="col-12">
                    <AmbiguousPicker candidates={candidates} onPick={handlePickCandidate} />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="layout-loi-ich mb-5">
            <h2 className="text-center mt-7 mb-0">Lợi ích hóa đơn điện tử</h2>

            <div className="p-3">
              <div className="row">
                <div className="col-12 col-md-3 col-lg-3">
                  <Card hoverable>
                    <div className="w-100 text-center">
                      <img src={AppResource.images.img_nghiep_vu} alt="" />
                    </div>
                    <Typography.Title
                      level={4}
                      className="font-weight-bold text-center"
                    >
                      ĐÁP ỨNG NGHIỆP VỤ
                    </Typography.Title>
                    <div className="item-text text-center">
                      Đảm bảo đáp ứng toàn bộ nghiệp vụ theo quy định của Tổng
                      cục thuế
                    </div>
                  </Card>
                </div>
                <div className="col-12 col-md-3 col-lg-3">
                  <Card hoverable>
                    <div className="w-100 text-center">
                      <img src={AppResource.images.img_hieu_qua} alt="" />
                    </div>
                    <Typography.Title
                      level={4}
                      className="font-weight-bold text-center"
                    >
                      TIẾT KIỆM - HIỆU QUẢ
                    </Typography.Title>
                    <div className="item-text text-center">
                      Tiết kiệm 90% chi phí in ấn, vận chuyển, lưu trữ và bảo
                      quản hóa đơn
                    </div>
                  </Card>
                </div>
                <div className="col-12 col-md-3 col-lg-3">
                  <Card hoverable>
                    <div className="w-100 text-center">
                      <img src={AppResource.images.img_an_toan} alt="" />
                    </div>
                    <Typography.Title
                      level={4}
                      className="font-weight-bold text-center"
                    >
                      AN TOÀN - BẢO MẬT
                    </Typography.Title>
                    <div className="item-text text-center">
                      Sử dụng công nghệ bảo mật nhiều lớp, an toàn tuyệt đối
                      trong việc quản lý và lưu trữ.
                    </div>
                  </Card>
                </div>
                <div className="col-12 col-md-3 col-lg-3">
                  <Card hoverable>
                    <div className="w-100 text-center">
                      <img src={AppResource.images.img_tu_van} alt="" />
                    </div>
                    <Typography.Title
                      level={4}
                      className="font-weight-bold text-center"
                    >
                      TƯ VẤN - HỖ TRỢ
                    </Typography.Title>
                    <div className="item-text text-center">
                      Triển khai nhanh, hỗ trợ thông báo phát hành hóa đơn, tư
                      vấn nghiệp vụ trong việc sử dụng hóa đơn.
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>

          <footer className="layout-footer text-center text-white p-8">
            <b>CÔNG TY CỔ PHẦN TƯ VẤN VÀ CHUYỂN GIAO CÔNG NGHỆ SƠN PHÁT</b>
            <p>
              <i className="fa-solid fa-location-dot mr-2"></i>
              <b>Địa chỉ:</b> Số 32/21 Số nhà 2, ngách 32, tổ 9, Phường Tân Lập,
              Thành phố Thái Nguyên, Tỉnh Thái Nguyên, Việt Nam{' '}
            </p>
            <p>
              <i className="fa-solid fa-phone mr-2"></i>
              <b>Hotline:</b> 02083.607.668
            </p>
            <p>
              <i className="fa-regular fa-envelope mr-2"></i>
              <b>Email:</b> hoadon@sonphat.vn
            </p>
          </footer>
        </div>
      </div>

      {invoice && (
        <ModalViewInvoice
          invoiceUrl={invoiceUrl}
          lookupCode={invoice?.lookupCode || invoiceLookupCode}
          invoice={invoice}
          showModalViewInvoice={showModalViewInvoice}
          setShowModalViewInvoice={setShowModalViewInvoice}
        />
      )}
    </>
  )
}

export default Search
